import { AxiosError, AxiosResponse } from "axios"
import { MenuData } from "./MainMenu/MainMenu"
import { crmApi, getCrmBaseUrlWithLang } from "./api/CrmApi"
import { MobileLinkFactory } from "./MobileLinkFactory"
import { CountryOption } from "./form/QuickFilterForm"

type DataResponse = {
	users: [],
	currentUserId: number,
	serverUrl: string,
	baseUrl: string,
	countryOptionData: CountryOption[],
	initJs?: string
}

class MobileCrmData {
	private static currentUserId: number

	private static users: Record<number, string>

	public static INIT_ACTION = "initData"

	public static FORM_ACTION = "getForm"

	public static FILTER_FORM_ACTION = "getFilterForm"

	public static LIST_ACTION = "getListData"

	public static FIRM_LIST_ACTION = "getFirmListData"

	public static RELATION_ACTION = "getEntityRelationData"

	public static RELATION_LIST_ACTION = "getEntityRelationListData"

	public static DELETE_ENTITY_ACTION = "formDeleteEntity"

	public static CLOSE_ENTITY_ACTION = "formCloseEntity"

	public static PERSON_LIST_ACTION = "getPersonList"

	public static COUNTRY_OPTION_DATA_ACTION = "getCountryOptionData"

	public static CONTACT_LIST_ACTION = "getContactList"

	public static ORDER_COLUMNS_ACTION = "getOrderColumns"

	public static DETAIL_VIEW_ACTION = "getDetailViewData"

	public static serverUrl: string

	private static menuDataProp: MenuData[]

	private static countryData: CountryOption[]

	static async loadData() {
		await crmApi.get( MobileLinkFactory.createActionLink( this.INIT_ACTION ) )
			.then( ( axiosResponse: AxiosResponse<DataResponse> ) => {
				MobileCrmData.users = axiosResponse.data.users
				MobileCrmData.currentUserId = axiosResponse.data.currentUserId
				MobileCrmData.serverUrl = axiosResponse.data.serverUrl
				MobileCrmData.countryData = axiosResponse.data.countryOptionData

				if( axiosResponse.data?.initJs ) {
					eval.call( window, axiosResponse.data.initJs )
				}
			} ).catch( ( error: AxiosError ) => {
				console.log( error.message )
				MobileCrmData.users = []
				MobileCrmData.currentUserId = 0
				MobileCrmData.serverUrl = ""
			} )
	}

	public static getCurrentUserId(): number {
		return this.currentUserId
	}

	static set menuData( value: MenuData[] ) {
		this.menuDataProp = value
	}

	static get menuData(): MenuData[] {
		return this.menuDataProp
	}

	static async loadMenuData() {
		await crmApi.get( MobileLinkFactory.createActionLink( "getMenuData" ) )
			.then( ( data: AxiosResponse<Array<MenuData>> ) => {
				MobileCrmData.menuData = data.data
			} ).catch( ( error ) => {
				console.log( error )
			} )
	}

	public static getCountryData(): CountryOption[] {
		return this.countryData
	}

	public static getUserNameById( userId: number ): string {
		return this.users[ userId ]
	}

	public static getBaseUrl(): string {
		return getCrmBaseUrlWithLang()
	}

	public static getActionUrl( action: string ): string {
		return this.getBaseUrl() + action
	}

	public static getDeleteEntityUrl(): string {
		return this.DELETE_ENTITY_ACTION
	}

	public static lastFormId: number
}

export default MobileCrmData
